import React from 'react';
import PropTypes from 'prop-types';

import CoOrdinate from "../Inputs/CoOrdinate";

export default class Placement extends React.Component
{
    static propTypes = {
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,

        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired
    };

    onChange = (key, value) => {
        if (! value) {
            value = 0;
        }

        this.props.onChange(key, value);
    };

    render()
    {
        return <div className="grid gap-2 grid-cols-2">

            <CoOrdinate
                label='X'
                value={this.props.x ? this.props.x.toString() : '0'}
                onChange={e => this.onChange('x', e.target.value)}
                onBlur={this.props.onBlur}
            />

            <CoOrdinate
                label='Y'
                value={this.props.y ? this.props.y.toString() : '0'}
                onChange={e => this.onChange('y', e.target.value)}
                onBlur={this.props.onBlur}
            />

            <CoOrdinate
                label='W'
                value={this.props.width ? this.props.width.toString() : '0'}
                onChange={e => this.onChange('width', e.target.value)}
                onBlur={this.props.onBlur}
            />

            <CoOrdinate
                label='H'
                value={this.props.height ? this.props.height.toString() : '0'}
                onChange={e => this.onChange('height', e.target.value)}
                onBlur={this.props.onBlur}
            />

        </div>;
    }
}
